import styled from 'styled-components';

export const InputLabel = styled.label`
  display: flex;
  & input {
    margin-right: 5px;
  }
`;
